import React, { useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { serverUtilities } from "../../services/serverutilities.service";
import { Mail, Phone, HelpCircle } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const FormContainer = styled.div`
  ${tw`relative max-w-md mx-auto p-8 rounded-3xl shadow-2xl`}

  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.4);

  form {
    ${tw`mt-6`}
  }

  h2 {
    ${tw`text-3xl sm:text-4xl font-bold text-gray-900 mb-4`}
  }

  input,
  textarea {
    ${tw`
      w-full bg-transparent text-black text-base font-medium
      border-b-2 border-gray-300 py-3
      focus:outline-none focus:border-indigo-600
      transition duration-200
    `};

    ::placeholder {
      ${tw`text-gray-600 px-4`}
    }
  }

  textarea {
    ${tw`resize-none`}
  }
`;

const IconRow = styled.div`
  ${tw`absolute top-[-30px] lg:left-[160px] left-[80px] transform -translate-x-1/2 gap-2 flex z-10`}
`;

const IconCircle = styled.div`
  ${tw`w-16 h-16 rounded-full flex items-center justify-center shadow-lg`}
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
`;

const FormTitle = styled.h2`
  ${tw`text-center text-3xl font-bold text-gray-900 mb-8`}
`;

const TwoColumn = tw.div`flex flex-col justify-between`;
const Column = tw.div`xs:w-full xs:flex-col xs:m-0 flex sm:flex-row`;
const TextAreaWrapper = tw.div`flex flex-row`;
const InputContainer = tw.div` flex flex-col xs:w-full sm:w-1/2 sm:flex-row py-5  sm:mr-5 lg:flex-col`;
const Label = tw.label`  font-semibold text-sm text-gray-700 mt-0 py-3 
pointer-events-none transform origin-left transition-all duration-200 ease-in-out`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full  mt-6 py-3 bg-[#01325b] text-white rounded 
font-bold tracking-wide text-sm transition duration-300 transform 
focus:outline-none focus:shadow-outline hover:bg-white hover:text-brand-100 hocus:-translate-y-px`;
const ErrorLabel = tw.p`text-red-500 text-lg mt-5`;

const FormErrors = tw.p`text-red-500 text-sm mt-3`;
const SuccessLabel = tw.p`text-white font-bold text-2xl mt-5`;

export default ({
  messageColor = "",
  fromPage = "",
  wappAllow = true,
  formActionUrl = "",
  textColor = "",
}) => {
  //////console.log(fromPage);
  let fields = {};
  const [msgVal, setError] = useState("");
  const [isDisable, setDisable] = useState("0");
  const handleChange = (e) => {
    //////console.log(e.target.name);
    fields[e.target.name] = e.target.value;
  };
  function gtag_report_conversion() {
    let url = window.location.href;
    var callback = function () {
      if (typeof url != "undefined") {
        window.location = url;
      }
    };
    window.gtag("event", "conversion", {
      send_to: "AW-10791263118/yDEICIu_gYsDEI631pko",
      event_callback: callback,
    });
    return false;
  }
  const sendLogin = (e) => {
    //////console.log(fields);
    //alert ("1");
    //////console.log("I am clicked");
    //e.preventDefault();
    fields["fname"] = document.getElementById("fname-input").value;
    fields["lname"] = document.getElementById("lname-input").value;
    fields["phone"] = document.getElementById("phone-input").value;
    fields["email"] = document.getElementById("email-input").value;
    fields["message"] = document.getElementById("message-input").value;
    fields["refUrl"] = window.location.href;
    // e.preventDefault();
    // console.log(validateForm());
    if (validateForm()) {
      //////console.log("valid true");

      serverUtilities.validateZeroBounceEmail(fields.email).then((data) => {
        // //////console.log(data);
        serverUtilities
          .addlead(
            fromPage,
            fields.fname,
            fields.lname,
            fields.email,
            fields.phone,
            fields.message,
            fields.refUrl,
            data.status
          )
          .then((leadData) => {
            //////console.log(leadData);
            if (leadData.status == "0") {
              setError(leadData.message);
              setDisable(leadData.status);
              gtag_report_conversion();
            } else {
              setError(leadData.message);
              setDisable(leadData.status);
            }
          });
      });
    }
  };
  function validateForm() {
    let formIsValid;
    setError("");
    const Emailregex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,3})$/i;
    if (fields.fname == "") {
      setError("*Please Enter Your Name");
      document.getElementById("fname-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    // if(fields.fname != null){
    //   if (fields.fname.match(/^[a-zA-Z]+$/)) {
    //     setError("*Please type only letters");
    //     document.getElementById('fname-input').focus();
    //   }
    // }
    if (fields.fname.length != "") {
      if (fields.fname.length < 3) {
        setError("*Please Enter Your Name between 4 to 8 characters");
        document.getElementById("fname-input").focus();
        formIsValid = false;
        return formIsValid;
      }
    }
    if (fields.lname == "") {
      setError("*Please Enter Your Last Name");
      document.getElementById("lname-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.lname.length != "") {
      if (fields.lname.length < 3) {
        setError("*Please Enter Your Last Name between 4 to 8 characters");
        document.getElementById("lname-input").focus();
        formIsValid = false;
        return formIsValid;
      }
    }

    if (fields.email == "") {
      setError("*Please Enter Your Email");
      document.getElementById("email-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.email != "" && Emailregex.test(fields.email) === false) {
      setError("Please Enter Valid Email");
      document.getElementById("email-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.phone == "") {
      setError("*Please Enter Your Phone Number");
      document.getElementById("phone-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.phone.length < 8) {
      setError("*Incorrect Phone Number. Use ISD code with number");
      document.getElementById("phone-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.message == "") {
      setError("*Please Enter Your Message");
      document.getElementById("message-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    return (formIsValid = true);
  }
  return (
    <FormContainer>
      {/* ICONS */}
      <IconRow>
        {/* EMAIL */}
        <a href="mailto:cavijenderaggarwalclasses@gmail.com" tw="no-underline">
          <IconCircle tw="bg-[#3f6c68] shadow-lg hover:scale-110 transition">
            <Mail size={40} tw="text-yellow-500" />
          </IconCircle>
        </a>

        {/* WHATSAPP */}
        <a
          href="https://wa.me/918920334084"
          target="_blank"
          rel="noreferrer"
          tw="no-underline"
        >
          <IconCircle tw="hover:scale-110 transition">
            <FaWhatsapp size={40} tw="text-green-500" />
          </IconCircle>
        </a>

        {/* PHONE */}
        <a href="tel:+918920334084" tw="no-underline">
          <IconCircle tw="bg-[#3f6c68] shadow-lg hover:scale-110 transition">
            <Phone size={40} tw="text-yellow-500" />
          </IconCircle>
        </a>
      </IconRow>

      <div tw="mx-auto max-w-4xl pt-10">
        {/* TITLE */}
        <FormTitle>Get Expert Career Guidance</FormTitle>

        {isDisable == "0" && (
          <form id="jhakkas">
            <TwoColumn>
              <Column>
                <InputContainer>
                  <Input
                    id="fname-input"
                    type="text"
                    name="fname"
                    placeholder="Your Name "
                    required
                    style={{
                      border: "none",
                      border: "1px solid white",
                      background: "#fff",
                      borderRadius: "40px",
                    }}
                  />
                </InputContainer>

                <InputContainer>
                  <Input
                    id="lname-input"
                    type="text"
                    name="lname"
                    placeholder="Last Name"
                    required
                    style={{
                      border: "none",
                      border: "1px solid white",
                      background: "#fff",
                      borderRadius: "40px",
                      color: "#000",
                    }}
                  />
                </InputContainer>
              </Column>

              <Column>
                <InputContainer>
                  <Input
                    id="email-input"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    required
                    style={{
                      border: "none",
                      border: "1px solid white",
                      background: "#fff",
                      borderRadius: "40px",
                    }}
                  />
                </InputContainer>

                <InputContainer>
                  <Input
                    id="phone-input"
                    type="number"
                    name="phone"
                    placeholder="Phone Number"
                    required
                    style={{
                      border: "none",
                      border: "1px solid white",
                      background: "#fff",
                      borderRadius: "40px",
                    }}
                  />
                </InputContainer>

                <Input
                  id="fromPage-input"
                  type="hidden"
                  name="fromPage"
                  value="{fromPage}"
                />
              </Column>
            </TwoColumn>

            <TwoColumn>
              <TextAreaWrapper>
                <InputContainer tw="flex-1">
                  <Label htmlFor="message-input">
                    Tell Us About Your Self and Your Career Aspirations ?
                  </Label>
                  <TextArea
                    id="message-input"
                    name="message"
                    placeholder=""
                    style={{
                      border: "none",
                      border: "1px solid white",
                      background: "#fff",
                      borderRadius: "4px",
                    }}
                  />
                </InputContainer>
              </TextAreaWrapper>
            </TwoColumn>

            <SubmitButton type="button" onClick={sendLogin}>
              Submit
            </SubmitButton>
          </form>
        )}

        {msgVal != "" && (
          <div>
            {isDisable == "0" ? (
              <ErrorLabel>{msgVal}</ErrorLabel>
            ) : (
              <SuccessLabel>{msgVal}</SuccessLabel>
            )}
          </div>
        )}
      </div>
    </FormContainer>
  );
};
